import { Box } from '@mui/material';
import { styles, colors, Typography, IconGraphy } from '@leapeasy/ui-kit';

export const ReportCard = ({ title, count, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        '&:hover': { opacity: 0.75 },
        cursor: 'pointer',
        borderRadius: `${styles.borderRadius.large}px`,
        border: `1px solid ${colors.black[300]}`,
        background: 'white',
        overflow: 'hidden',
        flex: '1 1 0%',
        minWidth: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Fixed title band so 1- vs 2-line labels keep sibling cards aligned. */}
      <Box
        padding="8px 16px"
        sx={{
          minHeight: 48,
          display: 'flex',
          alignItems: 'flex-start',
          boxSizing: 'border-box',
        }}
      >
        <Typography
          variant="body2"
          style={{ color: colors.neutral[900], lineHeight: 1.35, wordBreak: 'break-word' }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          background: '#F9F8F9',
          border: `1px solid ${colors.black[300]}`,
          borderRadius: `${styles.borderRadius.large}px`,
          padding: '16px',
          minWidth: 0,
          gap: '8px',
          flexGrow: 1,
        }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          variant="h3"
          style={{
            color: colors.purple[900],
            fontWeight: '500',
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          {count}
        </Typography>

        <IconGraphy icon="Arrow.NorthEast" style={{ color: '#867B8D', flexShrink: 0 }} />
      </Box>
    </Box>
  );
};
